import { useAuth, useCollection } from '@hb/react'
import { AnyObject, DropdownField, FieldTypes, IdField } from '@hb/shared'
import { forwardRef, useMemo } from 'react'
import { InputElement, InputProps } from '../../../../types/fields'
import { DropdownInput } from '../Select/DropdownInput'

const DatabaseDropdown: InputElement<IdField<AnyObject>> = forwardRef<
  { focus: () => void },
  InputProps<IdField<AnyObject>>
>((props, ref) => {
  const { input, field, meta, style, disabled, readOnly } = props
  const { collection, getItemText } = field

  const { items } = useCollection(collection)

  const isAdmin = useAuth(s => s.admin)

  const sorted = useMemo(() => {
    const options =
      items
        ?.filter(i => isAdmin || !i.isInactive)
        .map(i => ({
          text: `${getItemText ? getItemText(i) : i.name}${i.isInactive ? ' (Inactive)' : ''}`,
          id: i.id,
        })) ?? []

    return options.sort((a, b) => (b.text < a.text ? 1 : -1))
  }, [items, getItemText, isAdmin])

  const dropdownField = useMemo<DropdownField>(() => {
    const renderOption = field.renderOption
    return {
      ...field,
      type: FieldTypes.DROPDOWN,
      options: sorted,
      searchable: true,
      renderOption: renderOption
        ? option => {
            const item = items.find(i => i.id === option.id)
            return item ? renderOption(item) : option.text
          }
        : undefined,
    }
  }, [field, sorted, items])
  return (
    <DropdownInput
      style={style}
      ref={ref}
      meta={meta}
      field={dropdownField}
      input={input}
      disabled={disabled}
      readOnly={readOnly}
    />
  )
})

export default DatabaseDropdown
